module.exports = __webpack_public_path__ + "static/img/11areaA_10.209958e.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character1/通常使用/11areaA_10.png
// module id = 1003
// module chunks = 1